module.exports = __webpack_public_path__ + "static/media/mmsys_119.f4f76351.ico";